<div class="form-group" [formGroup]="formGroup">
  <textarea class="form-control" [rows]="formField.minRows" [placeholder]="formField.label"
    [formControlName]="formField.key"></textarea>
</div>
